import axios from 'axios'

const state = {
    list: [],
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
}

const options = {
    headers: {
        'Accept': 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
    }
};

const actions = {
    // Bills
    updateBill(context, payload) {
        return axios.put(process.env.VUE_APP_API_BASE_URL + '/bills/' + payload.billId, {
            number: payload.number,
            date: payload.date,
            comment: payload.comment
        }, options).then((response) => {
            return response
        })
    },

    updateBillFilter(context, payload) {
        return axios.put(process.env.VUE_APP_API_BASE_URL + '/bills/update/filter', {
            year: payload.year,
            month: payload.month
        }, options).then((response) => {
            return response
        })
    },

    deleteBill(context, payload) {
        return axios.delete(process.env.VUE_APP_API_BASE_URL + '/bills/'+payload.billId, options)
            .then((response) => {
                return response
            })
    },

    // Contracts
    getContractBills(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/bills/contracts', payload, options)
            .then((response) => {
                return response
            })
    },

    saveContractBill(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/bills/' + payload.contractId+'/contract/store', {
            number: payload.number,
            date: payload.date,
            comment: payload.comment,
            year: payload.year,
            month: payload.month
        }, options).then((response) => {
            return response
        })
    },

    // Interventions
    getInterventionsBill(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/bills/interventions', payload, options)
            .then((response) => {
                return response
            })
    },

    saveInterventionBill(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/bills/' + payload.interventionId+'/intervention/store', {
            number: payload.number,
            date: payload.date,
            comment: payload.comment,
            year: payload.year,
            month: payload.month
        }, options).then((response) => {
            return response
        })
    },
}

const getters = {
    list: state => state.list,
};

const bills = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default bills;
